// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"HJ-z","loadingMedia":"IJ-z","reviewsImagesAndVideos":"JJ-z","limitHeight":"KJ-z"};